import { spacing } from './tokens/spacing';

const chartPadding = spacing.sm + spacing.xs;

export const componentSizes = {
  cards: { statusCountMinWidth: 0, statusHeight: 48, metricValueHeight: 36 },
  auth: {
    guardMinHeight: 200,
    panelMaxWidth: 576,
    inputHeight: 40,
    placeholderWidth: 120,
    placeholderHeight: 70,
  },
  chips: { swatchSize: 10, xsHeight: 20 },
  charts: {
    height: 220,
    pieHeight: 120,
    margin: spacing.xl,
    dashboardPadding: chartPadding,
    durationBottomPadding: chartPadding,
    axisFontSize: 11,
  },
  details: {
    sideColumnMinWidth: 240,
    metaColumnMinWidth: 220,
    formMaxWidth: 360,
    codeMaxHeight: 420,
  },
  dataGrid: {
    skeletonHeight: 14,
    stateMinHeight: 360,
    statusBarHeight: 10,
    footerHeight: 43,
    columns: { xs: 60, sm: 80, md: 100, lg: 120, xl: 140, xxl: 160, max: 240 },
    execution: {
      nameMinWidth: 220,
      statusMinWidth: 160,
      typeMinWidth: 110,
      environmentMinWidth: 140,
      resultsMinWidth: 180,
      projectMinWidth: 140,
    },
    uploadTokens: {
      nameMinWidth: 160,
      createdMinWidth: 140,
      lastUsedMinWidth: 140,
      expiresMinWidth: 140,
      statusMinWidth: 120,
      actionsMinWidth: 200,
    },
    samples: { primaryMinWidth: 180, secondaryMinWidth: 120 },
  },
  dialogs: { actionMinWidth: 64, iconMinWidth: 24 },
  uploads: { listMaxHeight: 240 },
  forms: { inviteRoleWidth: 120, authNameMinWidth: 220, numberSpinnerStepperWidth: 32 },
  onboarding: { sectionHeight: 280 },
} as const;
